export default __webpack_public_path__ + "static/Tek_Railgun-2cbb2cc05df767793d90fdced4af318d.png";